import { useState } from 'react';
import Swal from 'sweetalert2';

function getCsrfToken() {
  const match = document.cookie.match(/(?:^|; )csrftoken=([^;]*)/);
  return match ? decodeURIComponent(match[1]) : null;
}

export const useForgetPasswordEmail = () => {
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const sendEmail = async (username) => {
    setIsLoading(true);
    setError(null);

    const headers = { 'Content-Type': 'application/json' };
    const csrfToken = getCsrfToken();
    if (csrfToken) {
      headers['X-CSRFToken'] = csrfToken;
    }

    try {
      const response = await fetch('/api/authenticate/sendforgetpasswordemail/', {
        method: 'POST',
        headers,
        credentials: 'same-origin',
        body: JSON.stringify({ username }),
      });

      if (!response.ok) {
        let message =
          'No active account found with this roll number. Verify your email first, or sign up.';
        try {
          const json = await response.json();
          if (json.detail && !String(json.detail).includes('CSRF')) {
            message = Array.isArray(json.detail) ? json.detail.join(' ') : json.detail;
          } else if (response.status === 403) {
            message =
              'Request blocked. Refresh the page and try again, or use the same browser you used to sign up.';
          }
        } catch (_) {
          /* use default message */
        }
        setError(message);
        Swal.fire({
          title: 'Could not send reset email',
          text: message,
          icon: 'error',
          confirmButtonText: 'OK',
        });
        return;
      }

      Swal.fire({
        title: 'Password Sent successfully',
        text: 'Please check your webmail',
        width: 600,
        icon: 'success',
        padding: '3em',
        background: '#fff',
        backdrop: `
          rgba(0,0,123,0.4)
          url("https://media.tenor.com/-AyTtMgs2mMAAAAi/nyan-cat-nyan.gif")
          left bottom
          no-repeat
        `,
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.href = '/login';
        }
      });
    } catch (e) {
      const message = 'Something went wrong. Please try again.';
      setError(message);
      Swal.fire({
        title: 'Something went wrong',
        text: message,
        icon: 'error',
        confirmButtonText: 'OK',
      });
    } finally {
      setIsLoading(false);
    }
  };

  return { sendEmail, isLoading, error };
};
